import {
  applyMiddleware, createStore, Middleware, Store,
} from 'redux';
import createSagaMiddleware from 'redux-saga';
import ReduxLogger from 'redux-logger';
import { persistStore } from 'redux-persist';
import { checkTokenExpirationMiddleware, catchErrors } from '@rootCommon/utilities';
import { isDevelopment } from '@rootCommon/constants/common';

import reducer, { RootState as RootStateType } from './reducers';
import rootSaga from './sagas';

const sagaMiddleware = createSagaMiddleware();
const middlewares: Middleware[] = [sagaMiddleware, checkTokenExpirationMiddleware, catchErrors];

if (isDevelopment) {
  middlewares.push(ReduxLogger);
}

const store: Store<RootStateType> = createStore(reducer, applyMiddleware(...middlewares));

sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export type RootState = RootStateType;
export const persistor = persistStore(store);
export default store;
